import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-7c443bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer reflectiveBandsModal" }
const _hoisted_2 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "steps mb-4" }
const _hoisted_9 = { class: "stepNumber" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "form-group mt-3" }
const _hoisted_12 = { class: "fw_700 mb-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_14 = ["label"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "defaultsPanel mt-4"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "defaultsPanel mb-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "defaultsPanel mb-4" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "defaultsPanel manufacturingDefaults mb-4" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = {
  key: 4,
  class: "summaryStep text-center"
}
const _hoisted_30 = { class: "text-muted mt-3" }
const _hoisted_31 = { class: "totalCard mt-4" }
const _hoisted_32 = { class: "d-flex justify-content-between mt-5" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.globalErrors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalErrors, (message, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Reflective Bands",
          text: "Reflective Bands"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepLabels, (label, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: label,
            class: _normalizeClass(["step", { active: _ctx.currentStep == index, completed: _ctx.currentStep > index }])
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(index + 1), 1),
            _createVNode(_component_localized_text, {
              class: "stepLabel",
              localizedKey: label,
              text: label
            }, null, 8, ["localizedKey", "text"])
          ], 2))
        }), 128))
      ]),
      (_ctx.currentStep == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Product selection",
                text: "Product selection"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Code",
                  text: "Code"
                })
              ]),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCode) = $event)),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applySelectedCode && _ctx.applySelectedCode(...args)))
              }, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedCodes, (group) => {
                  return (_openBlock(), _createElementBlock("optgroup", {
                    key: group.name,
                    label: group.name
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.code,
                        value: item.code
                      }, _toDisplayString(item.code) + " — " + _toDisplayString(item.description), 9, _hoisted_15))
                    }), 128))
                  ], 8, _hoisted_14))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.selectedCode]
              ])
            ]),
            (_ctx.selectedConfiguration)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Description",
                        text: "Description"
                      }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.description), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Group",
                        text: "Group"
                      }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.group), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Composition",
                        text: "Composition"
                      }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.composition), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Height (cm)",
                        text: "Height (cm)"
                      }),
                      _createTextVNode(":")
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.heightCm), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Raw material",
                text: "Raw material"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Height (cm)",
                    text: "Height (cm)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.heightCm), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Composition",
                    text: "Composition"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.composition), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Emission factor (kg CO2e/kg)",
                    text: "Emission factor (kg CO2e/kg)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.rawMaterialEmissionFactorKgCo2ePerKg), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_form_field, {
                  type: "number",
                  min: "0",
                  labelKey: "Length (cm)",
                  labelValue: "Length (cm)",
                  placeholderKey: "Length (cm)",
                  placeholderValue: "Length (cm)",
                  modelValue: _ctx.lengthCm,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lengthCm) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_form_field, {
                  type: "number",
                  min: "0",
                  labelKey: "Areal Density (g/m²)",
                  labelValue: "Areal Density (g/m²)",
                  placeholderKey: "Areal Density (g/m²)",
                  placeholderValue: "Areal Density (g/m²)",
                  modelValue: _ctx.arealDensityGramsPerSquareMeter,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.arealDensityGramsPerSquareMeter) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Transport",
                text: "Transport"
              })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Transport EF (kg CO2e/t·km)",
                    text: "Transport EF (kg CO2e/t·km)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.transportEmissionFactorKgCo2ePerTonneKm), 1)
              ])
            ]),
            _createVNode(_component_form_field, {
              type: "number",
              min: "0",
              labelKey: "Distance (km)",
              labelValue: "Distance (km)",
              placeholderKey: "Distance (km)",
              placeholderValue: "Distance (km)",
              modelValue: _ctx.distanceKm,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.distanceKm) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Manufacturing",
                text: "Manufacturing"
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Binder mass (kg)",
                    text: "Binder mass (kg)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.binderMassKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Binder EF",
                    text: "Binder EF"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.binderEmissionFactorKgCo2ePerKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Glass beads/film mass (kg)",
                    text: "Glass beads/film mass (kg)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.glassBeadsMassKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Glass beads/film EF",
                    text: "Glass beads/film EF"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.glassBeadsEmissionFactorKgCo2ePerKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "FR chemical mass (kg)",
                    text: "FR chemical mass (kg)"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.frChemicalMassKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "FR chemical EF",
                    text: "FR chemical EF"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.frChemicalEmissionFactorKgCo2ePerKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Adhesive EF",
                    text: "Adhesive EF"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.adhesiveEmissionFactorKgCo2ePerKg), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Grid electricity EF",
                    text: "Grid electricity EF"
                  }),
                  _createTextVNode(":")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.selectedConfiguration.gridElectricityEmissionFactorKgCo2ePerKwh), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_form_field, {
                  type: "number",
                  min: "0",
                  labelKey: "Adhesive mass (kg)",
                  labelValue: "Adhesive mass (kg)",
                  placeholderKey: "Adhesive mass (kg)",
                  placeholderValue: "Adhesive mass (kg)",
                  modelValue: _ctx.adhesiveMassKg,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.adhesiveMassKg) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_form_field, {
                  type: "number",
                  min: "0",
                  labelKey: "Electricity (kWh/kg)",
                  labelValue: "Electricity (kWh/kg)",
                  placeholderKey: "Electricity (kWh/kg)",
                  placeholderValue: "Electricity (kWh/kg)",
                  modelValue: _ctx.electricityKwhPerKg,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.electricityKwhPerKg) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentStep == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cradle-to-Gate Summary",
                text: "Cradle-to-Gate Summary"
              })
            ]),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.selectedCode) + " — " + _toDisplayString(_ctx.selectedConfiguration.description), 1),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Cradle-to-Gate Total",
                  text: "Cradle-to-Gate Total"
                })
              ]),
              _createElementVNode("strong", null, _toDisplayString(_ctx.finalGramsCo2e.toFixed(4)) + " gCO₂e", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        (_ctx.currentStep > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentStep--))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Back",
                text: "Back"
              })
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_33)),
        (_ctx.currentStep < 4)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-tertiary",
              disabled: !_ctx.currentStepIsValid,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentStep++))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Continue",
                text: "Continue"
              })
            ], 8, _hoisted_34))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn-tertiary",
              disabled: !_ctx.allInputsAreValid,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Confirm",
                text: "Confirm"
              })
            ], 8, _hoisted_35))
      ])
    ])
  ]))
}